<template>
    <div class="container">
        <div class="block">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span style="font-size:22px">欢迎关注公众号办理以下业务</span>
                </div>
                <div v-for="o in business" :key="o" class="item">
                    <li>{{ o }}</li>
                </div>
            </el-card>
        </div>
        <div class="block">
            <img src="../assets/images/qrcode-white.jpg" alt="联系我们" />
        </div>
    </div>
</template>
  

<script>
export default {
    name: 'Contact',
    data() {
        return {
            src: '../assets/qrcode-white.png',
            business: [
                "【AI对话】apikey获取",
                "ChatGPT账号购买",
                "ChatGPT技术实践交流",
                "文案工具需求建议"
            ]
        }
    },
    methods: {

    },
    beforeDestroy() {
        // source.close();
    }
}
</script>
  
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    /* align-items: flex-start; */
    /* height: 100vh; */
}

.block {
    width: 100%;
    height: auto;
    /* flex: 1; */
    display: block;
}

img {
    width: 100%;
    height: auto;
}

.item {
    font-size: 18px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}
</style>
  


// WEBPACK FOOTER //
// src/components/Contact.vue